import {DeepLinkActionBase} from "../deep-link-action-base";
import {Check} from "@sparkware/app-utils";

export class JackpotGamesDeeplinkAction extends DeepLinkActionBase {
  async execute(){
    const jackpotId = this.descriptor.actionParams.id;
    if(!Check.isNullOrUndefined(jackpotId)) {
       await this.services.partyJackpot.openPartyJackpotGamesDrawer(jackpotId);
    }
  }
}